"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _classificationPopup = _interopRequireDefault(require("./classificationPopup.vue"));
var _scrunchieArrangement = require("@/api/scrunchieArrangement/scrunchieArrangement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    classificationPopup: _classificationPopup.default
  },
  data: function data() {
    return {
      queryData: {
        type: '',
        page: {
          page: 1,
          size: 10
        }
      },
      tableData: []
    };
  },
  created: function created() {
    this.categoryListApi();
  },
  methods: {
    onAdd: function onAdd() {
      this.$refs.classificationPopup.open({
        type: 'add',
        name: '类目新增'
      });
    },
    onRefresh: function onRefresh() {
      this.categoryListApi();
    },
    onSwitchChange: function onSwitchChange(val, val1) {
      this.updateStatusApi(val.id, val1);
      // this.$confirm('是否确认编辑此上下线状态?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.updateStatusApi(val.id, val1)
      // })
    },
    handleEdit: function handleEdit(item) {
      this.$refs.classificationPopup.open({
        type: 'editor',
        id: item.id,
        name: '编辑活动',
        types: item.type
      });
    },
    // 删除
    handleDelete: function handleDelete(data) {
      var _this = this;
      this.$confirm('是否确认删除此配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteMaterialCategoryApi(data.id);
      });
    },
    // 列表
    categoryListApi: function () {
      var _categoryListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _scrunchieArrangement.categoryListApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.tableData = res.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function categoryListApi() {
        return _categoryListApi2.apply(this, arguments);
      }
      return categoryListApi;
    }(),
    // 上下线
    updateStatusApi: function () {
      var _updateStatusApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id, enable) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              console.log(id, enable);
              params = {
                id: id,
                enable: enable
              };
              _context2.n = 1;
              return (0, _scrunchieArrangement.updateStatusApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.categoryListApi();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function updateStatusApi(_x, _x2) {
        return _updateStatusApi2.apply(this, arguments);
      }
      return updateStatusApi;
    }(),
    // 删除
    deleteMaterialCategoryApi: function () {
      var _deleteMaterialCategoryApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                id: id
              };
              _context3.n = 1;
              return (0, _scrunchieArrangement.deleteMaterialCategoryApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
              }
              this.categoryListApi();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function deleteMaterialCategoryApi(_x3) {
        return _deleteMaterialCategoryApi2.apply(this, arguments);
      }
      return deleteMaterialCategoryApi;
    }()
  }
};